import { render, staticRenderFns } from "./no-data-compliance-section.vue?vue&type=template&id=7eaf8cc2&scoped=true&lang=pug"
import script from "./no-data-compliance-section.vue?vue&type=script&lang=ts"
export * from "./no-data-compliance-section.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eaf8cc2",
  null
  
)

export default component.exports